<template>
  <div id="app">
    <router-view name="Header" :key="$route.fullPath" @toSearch="toSearch"></router-view>
    <keep-alive exclude="PlaceOrder,PayOrder,ShopCart,GoodsDetail,BehalfDetail,Personal,Forget">
      <router-view ref="routerView" ></router-view>
    </keep-alive>
    <router-view name="Footer"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return {
      searchVal:''
    }
  },
  created() {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
  },
  methods : {   
    beforeunloadHandler (e) {
      //处理离开页面逻辑
    },
    toSearch(val){
      this.searchVal = val
      const name = this.$route.name
      if(name != 'search'){
        this.$router.push({
          name: 'search',
          query: {
            keywords: val
          }
        })
      }else{
        this.$refs.routerView.toSearch(val)
      }
     
    }
  }
}
</script>

<style lang="scss">
@import 'assets/css/reset.scss';
@import '~@smart/style';
#app{
  background: #F8F8F8;
  min-width: 1200px;

}
::-webkit-scrollbar{
            width:6px;
            height:6px;
/**/
  }
::-webkit-scrollbar-track{
    background: rgb(239, 239, 239);
    border-radius:2px;
}
::-webkit-scrollbar-thumb{
    background: #bfbfbf;
    border-radius:6px;
}
</style>
